import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { BoatDTO } from '../../models/dtos/boatDTO';
import { TranslateModule } from '@ngx-translate/core';

/**
 * EM-2589: seleção da embarcação a alocar na vaga do mapa (operação "Alocar Embarcação"), com busca por nome.
 * Recebe `data.boats` (barcos ativos sem vaga) e devolve no `close` o `BoatDTO` escolhido.
 */
@Component({
  selector: 'app-berth-map-select-boat',
  templateUrl: './berth-map-select-boat.component.html',
  styleUrls: ['./berth-map-select-boat.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownModule, ButtonModule, TranslateModule]
})
export class BerthMapSelectBoatComponent implements OnInit {
  boats: BoatDTO[] = [];
  selectedBoat: BoatDTO;

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.boats = this.config.data?.boats || [];
  }

  onConfirm(): void {
    if (this.selectedBoat) {
      this.ref.close(this.selectedBoat);
    }
  }

  onCancel(): void {
    this.ref.close();
  }
}
